<!--
 * @Author: QWX
 * @Description: 开票信息、开票记录
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-29 09:10:27
-->
<template>
  <el-form
    ref="relateForm"
    label-position="right"
    label-width="180px"
    disabled
  >
    <el-card class="m-b">
      <div slot="header">
        <span class="saas-card-header-name">开票信息</span>
      </div>
      <el-row  >
        <el-col :span="12">
          <el-form-item label="公司名称:" >
            <el-input readonly :value="basicForm.taxplarerCompany" placeholder="请选择单位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号:"  >
            <el-input readonly :value="basicForm.taxplarerCode" placeholder="自动读取回显"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行:" >
            <el-input readonly :value="basicForm.openBank" placeholder="自动读取回显"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号:"  >
            <el-input readonly :value="basicForm.bankAccount" placeholder="自动读取回显"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址:"  >
            <el-input readonly :value="basicForm.registerAddress" placeholder="自动读取回显"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册电话:">
            <el-input readonly :value="basicForm.registerPhone" placeholder="自动读取回显"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票金额(元):"  >
            <el-input  :value="basicForm.invoiceMoney" placeholder="请输入发票金额">
              <div slot="append">
                {{basicForm.currencyCh}}
              </div>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票种类:" >
            <el-radio-group :value="basicForm.invoiceType" >
              <el-radio
                v-for="(value, name) in enums.invoiceType"
                :key="name"
                :label="+name"
              >{{value}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="remark" >
            <el-input type="textarea" :value="basicForm.remark" :rows="4"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附件:" >
            <zs-upload  :multiple="false" :isDisabled="true" :value="basicForm.fileId">
            </zs-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <el-card v-if="isView">
      <div slot="header" >
        <span class="saas-card-header-name">开票记录</span>
      </div>
      <div class="paymentInfo-content">
        <el-row>
          <el-col :span="24">
            <div class="w50">
              <el-form-item label="供应商联系人：" prop="taxplarerCompany" >
                <el-input  :value="basicForm.taxplarerCompany" ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商联系电话：" prop="supplierPhone" >
              <el-input  :value="basicForm.supplierPhone" >
                <el-select
                  slot="prepend"
                  :value="basicForm.supplierPhonePrefix"
                  style="width:88px"
                >
                  <!-- <el-option label="+86" value="86"></el-option> -->
                  <el-option
                    v-for="(item, index) in enums.phoneAreaCodeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票时间：">
              <el-date-picker
                :value="basicForm.invoiceTime"
                class="w100"
                type="datetime">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票附件："  >
              <zs-upload  :multiple="false" :isDisabled="true" :value="basicForm.invoiceFileId">
              </zs-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票说明：">
              <el-input type="textarea" :value="basicForm.gysRemark" :rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-form>
</template>

<script>
import zsUpload from '@/components/zsUpload'
import { enums, getValue } from '@/lib/enum'
export default {
  components: {
    zsUpload
  },
  props: {
    basicForm: {
      type: Object,
      default: () => ({})
    },
    isView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      enums,
      getValue
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentInfo-content{
  padding-left: 20px;
  .title{
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin-bottom: 4px;
  }
   .paymentInfo-paid{
     margin-bottom: 24px;
      .finalCount span{
         color: #000000A6;
      }
   }
}
</style>
